import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const ArrowUp_md = (props) => {
    const width = props.width ? props.width + 'px' : '24px';
    const height = props.height ? props.height + 'px' : '24px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 24 24"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.29289 10.7071C3.90237 10.3166 3.90237 9.68342 4.29289 9.29289L11.2929 2.29289C11.6834 1.90237 12.3166 1.90237 12.7071 2.29289L19.7071 9.29289C20.0976 9.68342 20.0976 10.3166 19.7071 10.7071C19.3166 11.0976 18.6834 11.0976 18.2929 10.7071L13 5.41421L13 21C13 21.5523 12.5523 22 12 22C11.4477 22 11 21.5523 11 21L11 5.41421L5.70711 10.7071C5.31658 11.0976 4.68342 11.0976 4.29289 10.7071Z"
            />
        </SvgStyled>
    );
};

export default ArrowUp_md;
